/**
 * @file DetailHeadline/component.js
 * @copyright 2016 CBC/Radio-Canada. All rights reserved.
 */

type DetailHeadlineProps = {
    text: string;
    lang?: string;
};
/**
 * DetailHeadline component.
 *
 * @param {Object} props The provided component props
 * @returns {React.Component} The created React component
 */
export function DetailHeadline({ text, lang }: DetailHeadlineProps) {
    return (
        <h1
            className="detailHeadline"
            lang={lang}
            data-testid="detailHeadline"
            data-cy="detailHeadline"
        >
            {text}
        </h1>
    );
}

export default DetailHeadline;
